<template>
	<div class="navZcy">
		<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" background-color="#545c64" text-color="#fff" active-text-color="rgb(26, 188, 156)">
			<el-menu-item index="0"><!-- @select="handleSelect"-->
				<img src="../assets/img/title.png" height="100%" />
			</el-menu-item>
			<router-link to="/main">
				<el-menu-item index="1">系统首页</el-menu-item>
			</router-link>
			<el-submenu index="1">
				<template slot="title">数据中心</template>
				<router-link to="/part">
					<el-menu-item index="2-1">零件列表</el-menu-item>
				</router-link>
				<router-link to="/partGroup">
					<el-menu-item index="2-2">灯组列表</el-menu-item>
				</router-link>
				<router-link to="/houseProject">
					<el-menu-item index="2-3">整屋方案</el-menu-item>
				</router-link>
			</el-submenu>
			<el-submenu index="2">
				<template slot="title">管理中心</template>
				<router-link to="/frimTag">
					<el-menu-item index="3-1">供应商</el-menu-item>
				</router-link>
				<router-link to="/seriesTag">
					<el-menu-item index="3-6">系列表</el-menu-item>
				</router-link>
				<router-link to="/seriesType">
					<el-menu-item index="3-7">系列类型</el-menu-item>
				</router-link>
				<router-link to="/styleTag">
					<el-menu-item index="3-2">系列风格</el-menu-item>
				</router-link>
				<router-link to="/brandTag">
					<el-menu-item index="3-3">系列品牌</el-menu-item>
				</router-link>
				<router-link to="/partTag">
					<el-menu-item index="3-4">零件结构</el-menu-item>
				</router-link>
				<router-link to="/fixtureTag">
					<el-menu-item index="3-5">零件材质</el-menu-item>
				</router-link>
				<router-link to="/sizeType">
					<el-menu-item index="3-8">尺寸类型</el-menu-item>
				</router-link>
			</el-submenu>
			<el-menu-item index="5" @click="logout()" style="float: right;">注销登录</el-menu-item>
			<el-submenu index="6" style="float: right;">
				<template slot="title">账户设置</template>
				<router-link to="/userAdmin">
					<el-menu-item index="6-1">用户管理</el-menu-item>
				</router-link>
				<router-link to="/accountAdmin">
					<el-menu-item index="6-2">修改密码</el-menu-item>
				</router-link>
			</el-submenu>
			<!--<router-link to="/accountAdmin">
				<el-menu-item index="4" style="float: right;">账户设置</el-menu-item>
			</router-link>-->
		</el-menu>
	</div>
</template>

<script>
export default {
	props: ['num'],
	data() {
		return {
			activeIndex: "1"
		}
	},
	methods: {
		logout(){
			this.$router.push({path: '/',query: ''})
			sessionStorage.setItem("sessionId","")
		}
	},
	mounted() {
		this.activeIndex = this.num;
	}
}
</script>

<style>
.fr {
	float: right;
}

a {
	text-decoration: none;
}

.navZcy {
	width: 100%;
	background: #666;
}

.el-submenu .el-menu-item {
	text-align: center;
	min-width: 0;
}

.menuR a {
	display: inline-block;
	height: 60px;
	line-height: 60px;
	border-bottom: 2px solid transparent;
	padding: 0 20px;
	: block;
	border-bottom-color: transparent;
	color: rgb(255, 255, 255);
	background-color: rgb(84, 92, 100);
	text-decoration: none;
	font-size: 14px;
}

.menuR a:hover {
	background: rgb(67, 74, 80);
}

.menuR a.active {
	color: rgb(26, 188, 156);
}
</style>


// WEBPACK FOOTER //
// src/components/nav.vue